(function () {
  const container = document.querySelector('[data-section-type="product"]');
  if (!container) return;

  const variantJsonEl = container.querySelector('[data-variant-json]');
  if (!variantJsonEl) return;

  let variants;
  try {
    variants = JSON.parse(variantJsonEl.textContent);
  } catch (e) {
    return;
  }

  const option1Select = container.querySelector('.dynamic-variant-input[data-index="option1"]');
  const option2Select = container.querySelector('.dynamic-variant-input[data-index="option2"]');
  if (!option2Select) return;

  const colorSwatchGroup = container.querySelector('[data-index="option1"]');
  if (!colorSwatchGroup) return;

  let userSelectedSize = false;

  function updateColorSwatches() {
    const selectedSize = option2Select.value;
    const swatches = colorSwatchGroup.querySelectorAll(
      'button.product__color-swatch[data-option-value]'
    );

    if (!swatches.length) return;

    if (!userSelectedSize) {
      swatches.forEach(s => {
        s.classList.remove('np-swatch--unavailable');
        s.classList.remove('disabled');
      });
      return;
    }

    swatches.forEach(swatch => {
      const color = swatch.dataset.optionValue;
      const hasAvailable = variants.some(
        v => v.option1 === color && v.option2 === selectedSize && v.available
      );
      // 'disabled' activates the theme's built-in diagonal strikethrough ::after
      // 'np-swatch--unavailable' adds pointer-events:none + opacity
      swatch.classList.toggle('disabled', !hasAvailable);
      swatch.classList.toggle('np-swatch--unavailable', !hasAvailable);
    });
  }

  option2Select.addEventListener('change', () => {
    userSelectedSize = true;
    requestAnimationFrame(updateColorSwatches);
  });

  if (option1Select) {
    option1Select.addEventListener('change', () => requestAnimationFrame(updateColorSwatches));
  }

  updateColorSwatches();
})();
